<template>
  <v-container background fluid pa-3>
    <v-layout row wrap pa-3 style="background-color:#fff; margin-top:5px; border-radius:5px;">
      <v-flex xs12>
        <v-layout row wrap>
          <v-flex xs6>
            <v-layout row wrap>
              <v-btn color="primary" class="hidden-xs-only" @click="doCopyTable()">
                <v-icon class="mr-2">fa-clipboard</v-icon>
                <span>{{$t('CopytoClipboard')}}</span>
              </v-btn>
              <v-btn color="primary" @click="downloadexcel()">
                <v-icon class="mr-2">fa-file-excel</v-icon>
                <span>{{$t('Exportexcel')}}</span>
              </v-btn>
            </v-layout>
          </v-flex>
          <v-flex xs12 class="scroll-able">
            <table id="table_detail">
              <thead>
                <!-- <tr>
                  <th class="text-left" colspan="4">{{i}}</th>
                </tr>-->
                <!-- <tr>
                  <th
                    nowrap
                    class="text-left topic-color"
                    width="5%"
                    colspan="2"
                  >ชื่อกิจการ Company Name(25 ตัวอักษร)</th>
                  <th nowrap class="text-left topic-color" width="5%">เลขที่บัญชีของกิจการ(10 หลัก)</th>
                  <th
                    nowrap
                    class="text-left topic-color"
                    width="5%"
                  >วันที่มีผล Effective Date [dd/mm/20yy]</th>
                </tr>
                <tr>
                  <th colspan="2">{{address_setting.companyname}}</th>
                  <th>3152638932</th>
                  <th>31/05/2020</th>
                </tr>-->
                <tr>
                  <th nowrap class="text-left topic-color">ลำดับ</th>
                  <th nowrap class="text-left topic-color">ชื่อธนาคาร</th>
                  <th nowrap class="text-left topic-color">ชื่อบัญชี(35 ตัวอักษร)</th>
                  <th nowrap class="text-left topic-color">เลขที่บัญชี</th>
                  <th nowrap class="text-left topic-color">จำนวนเงิน</th>
                </tr>
              </thead>
              <tbody v-for="(items,i) in listpaymenttype" :key="i">
                <tr class="text-left">
                  <td style="padding:5px;font-size:18px" colspan="4">{{i}}</td>
                </tr>
                <tr style="text-align:center" v-for="(item,j) in items" :key="j">
                  <td>{{j+1}}</td>
                  <td>{{item.bankName}}</td>
                  <td>{{item.bookName}}</td>
                  <td>{{item.bankCode}}</td>
                  <td>{{formatNumber(item.total_balance)}}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr style="text-align:center">
                  <td colspan="4">รวมยอดเงินทั้งหมด</td>
                  <td>{{formatNumber(totalamount)}}</td>
                </tr>
              </tfoot>
            </table>
          </v-flex>
        </v-layout>
        <v-layout row wrap style="margin-top:10px;">
          <v-flex lg6 sm6 md6 xs12></v-flex>
          <v-flex lg6 sm6 md6 xs12 text-lg-right text-sm-right>
            <span
              style="font-size:16px"
            >{{$t('Totallist') + ' : '}}&nbsp;&nbsp;{{data.length}}&nbsp;&nbsp; {{$t('List')}}</span>
          </v-flex>
        </v-layout>
        <v-layout row wrap style="margin-top:5px;">
          <v-flex lg6 sm6 md6 xs12></v-flex>
          <v-flex lg6 sm6 md6 xs12 text-lg-right text-sm-right>
            <span style="font-size:16px">
              {{$t('Totalsalary') + ' : '}}&nbsp;&nbsp;
              <span
                class="text-salary"
              >{{formatNumber(totalamount)}}</span>
              &nbsp;{{$t('baht')}}
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
/* eslint-disable */
import { mapState, mapActions, mapMutations } from "vuex";
import PayrollService from "@/services/PayrollService";
import SettingService from "@/services/SettingService";
import Numeral from "numeral";
import XLSX from "xlsx";
import jsPDF from "jspdf";
import pdf from "vue-pdf";
export default {
  created: async function () {
    this.ListDetailByDocNo(this.$route.params.docno);
    this.docno = this.$route.params.docno;
    this.admin = localStorage._is_admin;
    this.getCompanyAddress();
  },
  data: () => ({
    data: [],
    listbankdetail: [],
    totalamount: 0,
    address_setting: {
      roworder: 0,
      address: "",
      companyname: "",
      building: "", //อาคาร
      room_no: "", //ห้อง
      floor: "", //ชั้น
      village: "", //หมู่บ้าน
      house_no: "", //บ้านเลขที่
      village_no: "", //หมู่ที่
      alley_lane: "", //ตรอก/ซอย
      road: "", //ถนน
      subdistrict_subarea: "", //ตำบล/แขวง
      district_area: "", //อำเภอ/เขต
      province: "", //จังหวัด
      postcode: "", //รหัสไปรษณีย์
      telephone1: "",
      telephone2: "",
      code: "000-1",
      editor_code: "",
      imageLogo: "",
      taxpayer_number: "",
      line_id: "",
      facebook: "",
      twitter: "",
    },
    listpaymenttype: [],
  }),
  methods: {
    ...mapActions("toolbar", ["setToolbar"]),
    ...mapActions("app", ["commitSetToolbar", "commitSetShowLoading"]),
    ...mapState("permissionmenu", ["permission_List"]),
    ListDetailByDocNo(doc_no) {
      PayrollService.getPayrollDetailByDocNo(doc_no)
        .then((res) => {
          console.log("ListDetailByDocNo", res.data);
          res.data.forEach((element) => {
            if (element.isResign == false) {
              this.data.push(element);
            } else if (element.isResign == true && element.totalEarning > 0) {
              this.data.push(element);
              console.log("else", element);
            }
          });
          this.listpaymenttype = this.groupByPaymentType(
            this.data,
            "paymentType"
          );
          // this.listbankdetail = this.groupByBank(this.data, "bankName");

          console.log("listbankdetail: ", this.listbankdetail);
          console.log("listpaymenttype: ", this.listpaymenttype);
          this.totalamount = 0;
          this.data.forEach((element) => {
            this.totalamount += element.total_balance;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    groupByPaymentType(array, key) {
      let list = {};
      let keylists = {};
      let result = {};
      array.forEach((item) => {
        let keyName = item[key];

        if (item.paymentType == "" || item.paymentType == undefined) {
          //keyName = "ไม่มีชื่อธนาคาร";
        }
        if (item.paymentType == 0) {
          keyName = "เงินโอน";
        } else if (item.paymentType == 1) {
          keyName = "พร้อมเพย์";
        } else if (item.paymentType == 2) {
          keyName = "เงินสด";
        } else if (item.paymentType == 3) {
          keyName = "อื่นๆ";
        }
        if (!list[item.paymentType]) {
          //list[item.bankName] = "ไม่มีชื่อธนาคาร";
        }

        if (!result[keyName]) {
          result[keyName] = [];
        }
        item.paymentType = list[item.paymentType];
        result[keyName].push(item);
      });
      return result;
    },
    // groupByBank(array, key) {
    //   let list = {};
    //   let keylists = {};
    //   let result = {};
    //   array.forEach((item) => {
    //     let keyName = item[key];

    //     if (item.bankName == "" || item.bankName == undefined) {
    //       keyName = "ไม่มีชื่อธนาคาร";
    //     }
    //     if (!list[item.bankName]) {
    //       //list[item.bankName] = "ไม่มีชื่อธนาคาร";
    //     }

    //     if (!result[keyName]) {
    //       result[keyName] = [];
    //     }
    //     item.bankName = list[item.bankName];
    //     result[keyName].push(item);
    //   });
    //   return result;
    // },
    formatNumber(val, digit = 0) {
      if (val == 0) {
        return 0;
      }

      if (digit > 0) return Numeral(val).format("0,0.00");

      return Numeral(val).format("0,0");
    },
    getCompanyAddress() {
      this.commitSetShowLoading(true);
      SettingService.getCompanyAddress()
        .then((res) => {
          if (res.data.content.length > 0) {
            this.address_setting = res.data.content[0];
            if (
              this.address_setting.imageLogo != "" &&
              this.address_setting.imageLogo != null &&
              this.address_setting.imageLogo != undefined
            ) {
              this.img = this.address_setting.imageLogo;
            }
            console.log("address_setting: ", this.address_setting);
          }
        })
        .catch((err) => {
          this.commitToggleAlertDialog({
            status: true,
            message: err.response.data,
          });
        })
        .then(() => {
          this.commitSetShowLoading(false);
        });
    },
    doCopyTable() {
      let el = document.getElementById("table_detail");
      let body = document.body;
      let range;
      let sel;
      if (document.createRange && window.getSelection) {
        range = document.createRange();
        sel = window.getSelection();
        sel.removeAllRanges();
        try {
          range.selectNodeContents(el);
          sel.addRange(range);
        } catch (e) {
          range.selectNode(el);
          sel.addRange(range);
        }
      }
      document.execCommand("Copy");
      alert("Copy Table to Clipboard");
    },
    downloadexcel() {
      var config = { raw: true, type: "string" };
      var payroll = XLSX.utils.table_to_sheet(
        document.getElementById("table_detail"),
        config
      );
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, payroll, "payroll");
      XLSX.writeFile(wb, "reportbank.xlsx");
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css?family=Kanit&display=swap");
้ h1,
h2,
h3,
h4,
h5,
h6,
span,
p {
  font-family: "Kanit", sans-serif;
}
.v-input--selection-controls {
  margin-top: 0;
}
.button-wrapper {
  position: relative;
  width: 150px;
  text-align: center;
  margin-top: 5px;
  margin-right: 15px;
  margin-bottom: 5px;
}

.button-wrapper span.label {
  position: relative;
  display: inline-block;
  width: 100%;
  background: #00bfff;
  cursor: pointer;
  color: #fff;
  padding: 10px 0;
  text-transform: uppercase;
  font-size: 12px;
  box-shadow: 0px 2px 2px grey;
}

#file {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 50px;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}
.checkEmp .theme--light.v-icon {
  color: #1976d2 !important;
}
#img_container {
  width: 500px;
  display: table-cell;
  vertical-align: middle;
}
#img_container img {
  height: 150px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 50px;
  margin-bottom: 20px;
  display: block;
}
table,
td,
th {
  border: 1px solid black;
  height: 40px;
  font-size: 16px;
}
.topic-color {
  background-color: #1976d2;
  color: #ffff;
}
.v-card_text {
  padding: 20px 20px 20px 25px !important;
  width: 100%;
}
.text-tax {
  color: red;
  font-weight: 400;
  padding-left: 1px;
}
.text-salary {
  color: green;
  font-weight: 400;
  padding-left: 1px;
}
</style>


